module.exports = __webpack_public_path__ + "img/arrow-up-square.674ca4d1.svg";